import {Period} from '../../common/model/period.model';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {IndirizzoEntitaLocale} from './indirizzoentitalocale.model';
import {TipoEntitaLocale} from '../../+configurazione/tipoentitalocale/tipoentitalocale.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Select2Template} from '../../common/template/select2-template';
import {Helpers} from '../../common/helpers/helpers';

export class EntitaLocale extends Period {

  constructor(protected id: number,
                public descr: string,
                public tipo: TipoEntitaLocale,
                public sedeDisagiata: Boolean,
                public codiceIstat: string,
                public inizioValidita: string,
                public fineValidita: string,
                public indirizzi: IndirizzoEntitaLocale[],
                public entitaOrganizzative: EntitaOrganizzativa[],
  ) {
    super(id, inizioValidita, fineValidita);
  }


  public static getTableKeys() {
    return ['tipologia', 'indirizzo', 'descr', 'entitaOrganizzative', 'inizioValidita', 'fineValidita'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('tipologia', new TableRowValue(this.tipo.getLabel(), null));
    rowValues.set('indirizzo', new TableRowValue(this.getIndirizzoPrincipale(), Select2Template.stradario));
    rowValues.set('descr', new TableRowValue(this.descr, null));
    rowValues.set('entitaOrganizzative', new TableRowValue(this.entitaOrganizzative.length, null));
    rowValues.set('inizioValidita', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('fineValidita', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return this.tipo.getLabel();
  }

  public getIndirizzoPrincipale() {
    const indirizziPrincipali = this.indirizzi.filter( indirizzo => {
      return indirizzo.principale;
    });
    if (indirizziPrincipali.length === 0) {
      return null;
    }
    return  indirizziPrincipali[0].indirizzo;
  }

  public getIndirizzoDisponibile() {
    const indirizzoPrincipale = this.getIndirizzoPrincipale();
    if (indirizzoPrincipale) {
      return indirizzoPrincipale;
    }

    const altriIndirizzi = this.getAltriIndirizzi();
    if (altriIndirizzi.length > 0) {
      return altriIndirizzi[0];
    }
    return null;
  }

  public getAltriIndirizzi() {
    return this.indirizzi.filter( indirizzo => {
      return !indirizzo.principale;
    }).map(indirizzoEntitaLocale => indirizzoEntitaLocale.indirizzo);
  }

}

